<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Drawer from '@uiKit/elements/Drawer.vue'
import EmptyState from '@uiKit/components/EmptyState.vue'

// Right-hand notifications panel opened from the header bell.
//
// Placeholder: seller-service has no notifications feed yet, so the drawer only
// ever shows the empty state. When the feed lands, a container takes over the
// query and this component renders the list it is handed.
const open = defineModel<boolean>({ required: true })
</script>

<template>
  <Drawer v-model="open" position="right" width="400px" header="Notifications">
    <Box direction="col" class="notifications-drawer__body">
      <EmptyState
        icon="bell"
        size="compact"
        title="No notifications yet"
        description="Updates on your sell requests, onboarding and payouts will show up here."
      />
    </Box>
  </Drawer>
</template>

<style scoped>
.notifications-drawer__body {
  min-height: 100%;
}
</style>
